/*-----------------------------------------------------------------
- Export components
-----------------------------------------------------------------*/
const components = {};

// Load files
const importedFiles = require.context('@rogues/ProfileOrders/types', true, /\.vue$/);

// Merge configs
importedFiles.keys().forEach((fileName) => {
    const file = importedFiles(fileName).default;
    components[fileName.split('/')[1].replace('.vue', '')] = file;
});

export default components;
